<template>
  <div v-if="role == 'user'">
    <h3 class="ml-4">You don't have permission on this page</h3>
  </div>
  <div v-else>
    <vs-row class="mb-3" >
      <vs-button color="dark" disabled type="flat"><h5>Setting  /  User</h5></vs-button>
    </vs-row>
    <!-- <b-breadcrumb style="background-color: #ffffff; padding-left: 0px;">
    <b-breadcrumb-item active><h5>Setting</h5></b-breadcrumb-item>
    <b-breadcrumb-item active><h5>User</h5></b-breadcrumb-item>
  </b-breadcrumb> -->
    <vs-card style="border-radius: 20px;">
    <vs-row >
      <h3 class="mt-2" style="color: #111111"> Administrator {{this.admin.name}}</h3>
      <vs-spacer />
        <!-- <vs-button color="#007bff" type="line" icon="person_add" v-b-modal.adduser1 >Add New User</vs-button> -->
         <vs-tooltip  text="Add New User" position="top" >
             <h6> <vs-button color="success"  style="border-radius: 20px;" size="sm" icon="person_add" v-b-modal.adduser1 type="filled">Add New User</vs-button></h6>
        </vs-tooltip>&nbsp;&nbsp;
    </vs-row>
       <vs-row vs-w="12">
            <vs-col  class="mt-3" vs-type="flex"  vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12" >
              <vs-input style="width : 250px;" icon-no-border icon="account_circle" label-placeholder="Username" v-model="this.admin.username" />
            </vs-col>
            <vs-col class="mt-3" vs-type="flex"  vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
              <vs-input style="width : 250px;" icon-no-border icon="email" label-placeholder="Email" v-model="this.admin.email"/>
              <vs-button color="warning" type="flat" size="small" icon="create" @click="editadminemail">Edit</vs-button>
            </vs-col>
            <vs-col class="mt-3" vs-type="flex"  vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
              <vs-input style="width : 250px;" icon-no-border icon="alternate_email" label-placeholder="Line" v-model="this.admin.line" />
            </vs-col>
          </vs-row>
          <vs-row vs-w="12">
            <vs-col class="mt-3" vs-type="flex"  vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
             <vs-input style="width : 250px;" icon-no-border icon="lock"  label-placeholder="Password"   label="Password" v-model="this.p" />
          <vs-button color="warning" type="flat" size="small" icon="create" @click="editAdminPWD">Edit</vs-button>
  </vs-col>
</vs-row>
    </vs-card>
    <vs-card style="border-radius: 20px;">
    <!-- <vs-row v-if="seleactdatatable!=false">cmfkmvof {{this.seleactdatatable}}</vs-row> -->
       <vs-tabs alignment="right" color="#555555">
      <vs-tab  icon="person" label="Active Users"><br>
         <!-- <div class="text-uppercase center text-bold">id selected: {{selected}} </div> -->
         <vs-row  >
            <vs-dropdown  >
                <vs-button  class="mr-1"  style="color: #111111" color="rgba(9, 30, 66, 0.04)" type="filled"  icon="toc"   id="show-btn"  >Bulk Actions</vs-button>
                <!-- <vs-button  class="mr-2"   color="dark" type="line"  icon="toc"   id="show-btn"  >Bulk Actions</vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="selectedReinvite(selected)">
                      <vs-icon icon="reply" class="mr-1" size="15px" ></vs-icon> Re-invite
                  </vs-dropdown-item>
                  <vs-dropdown-item  @click="selectedInactivate(selected)" >
                        <vs-icon icon="voice_over_off" class="mr-1" size="15px" ></vs-icon> Inactivate
                  </vs-dropdown-item>
                  <vs-dropdown-item  @click="showModalSelectedDelete">
                      <vs-icon icon="delete" class="mr-1" size="15px" ></vs-icon> Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
                <vs-spacer />
        <vs-tooltip  text="Download a PDF" position="top" >
          <vs-button  radius class="mr-2"  color="#333f50" @click="exportPDF(printUser='activeUsers')" type="line"   icon="picture_as_pdf"></vs-button></vs-tooltip>
          <vs-tooltip  text="Export" position="top" >
          <vs-button  class="mr-2"  radius @click="onExport(printUser='activeUsers')" color="#333f50" type="line"  icon="cloud_download"></vs-button></vs-tooltip>
         </vs-row>
         <br>
        <div> 
          <vs-table hoverFlat="false" search  :data="activeUserList" style="background-color: #F2F3F4; border-radius: 20px;">
        <template slot="header" >
          <h5 class="ml-3">Users​</h5> 
               </template>
      <template  slot="thead">
        <vs-th style="padding: 0px">
             <input type="checkbox" v-model="selectAllActive" @click="selectActive">
        </vs-th>
     <vs-th style="padding: 0px">
          
        </vs-th>
        <vs-th 
         style="padding: 0px" sort-key="id">
          <span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          ID
        </vs-th>
        <vs-th style="padding: 0px" sort-key="name"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Name
        </vs-th>
        <vs-th style="padding: 0px" sort-key="username"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Username
        </vs-th>
        <vs-th style="padding: 0px" ><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Password
        </vs-th>
        <vs-th style="padding: 0px" sort-key="email"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          E-mail
        </vs-th>
        <vs-th style="padding: 0px" sort-key="email"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Role
        </vs-th>
        <vs-th style="padding: 0px" sort-key="email"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Login Status
        </vs-th>
        <vs-th style="padding: 0px"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          LINE
        </vs-th>
         <vs-th style="padding: 0px" sort-key="email"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          User Status
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
           <vs-td style="width : 40px;">
            	<input type="checkbox" :value="data[indextr].id" v-model="selected" @click="select">
          </vs-td>
          <vs-td :data="data[indextr].active" style="width : 280px;">
              <div class="w3-hide-small  w3-hide-medium">
                <vs-button   color="primary" type="flat"  icon="reply" id="show-btn"  @click="reinvite(data[indextr])" >Re-invite</vs-button>
                <vs-button class="text-warning  " color="warning" type="flat" icon="create" @click="view(data[indextr])">Edit</vs-button>
                <vs-button class="text-danger  " color="danger" type="flat" icon="delete" v-b-modal.modal-delete @click="buttonDelete=data[indextr]">Delete</vs-button>
              </div>
              <!-- Responsive -->
              <vs-dropdown vs-trigger-click left class="cursor-pointer w3-hide-large">
                <a class="text-dark" href="#">
                  <span> <vs-icon size="18px" icon="more_vert"  color="black"></vs-icon> </span>
                </a>
                <vs-dropdown-menu class="topbar-dd">
                  <vs-dropdown-item @click="reinvite(data[indextr])"><span><vs-icon size="15px" class="mr-1" icon="reply" ></vs-icon></span>Re-invite</vs-dropdown-item>
                  <vs-dropdown-item @click="view(data[indextr])"><span><vs-icon class="mr-1" icon="create" size="15px" ></vs-icon></span>Edit</vs-dropdown-item>
                  <vs-dropdown-item  @click="buttonDelete=data[indextr],showModal()"><span><vs-icon class="mr-1" size="15px" icon="delete" ></vs-icon></span>Delete</vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>
          </vs-td>
           <vs-td>
            {{indextr+1}}
          </vs-td>
          <vs-td>
            {{data[indextr].name}}
          </vs-td>
          <vs-td>
            {{data[indextr].username}}
          </vs-td>
          <vs-td>
            {{data[indextr].password}}
          </vs-td>
          <vs-td>
           {{data[indextr].email}}  
          </vs-td>
          <vs-td>
           <span v-if="data[indextr].admin==null">Admin</span>
           <span else>User </span>
          </vs-td>
           <vs-td>
            <vs-icon icon="fiber_manual_record" v-if="data[indextr].islogin" color="#5fa74b" ></vs-icon>
            <vs-icon icon="fiber_manual_record" v-else color="#d9d9d9"></vs-icon>
          </vs-td>
          <vs-td>
            <vs-icon v-if="data[indextr].line == null" icon="remove" color="red"></vs-icon>
            <vs-icon v-else icon="check_box" color="green"></vs-icon>
          </vs-td>
          <vs-td>
             <vs-switch color="success" v-model="data[indextr]" @click="inactivate(data[indextr])">
                <span slot="on">Active</span>
                <span slot="off">Inactive</span>
              </vs-switch>
          </vs-td>
        </vs-tr>
      </template>
          </vs-table>
        </div>
      </vs-tab>
      <vs-tab  icon="voice_over_off" label="Inactive Users"><br>
        <vs-row>
          <vs-dropdown>
            <vs-button style="color: #111111" color="rgba(9, 30, 66, 0.04)" type="filled"  icon="toc"   id="show-btn"  >Bulk Actions</vs-button>
            <vs-dropdown-menu>
                <vs-dropdown-item  @click="selectedReactivate(selected)" >
                      <vs-icon icon="person" class="mr-1" size="15px" ></vs-icon> Activate
                </vs-dropdown-item>
                <vs-dropdown-item @click="showModalSelectedDelete">
                    <vs-icon icon="delete" class="mr-1" size="15px" ></vs-icon> Delete
                </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <vs-spacer />
        <vs-tooltip  text="Download a PDF" position="top" >
          <vs-button  radius class="mr-2"  color="#333f50" @click="exportPDF(printUser='inactiveUsers')" type="line"   icon="picture_as_pdf"></vs-button></vs-tooltip>
          <vs-tooltip  text="Export" position="top" >
          <vs-button  class="mr-2"  radius @click="onExport(printUser='inactiveUsers')" color="#333f50" type="line"  icon="cloud_download"></vs-button></vs-tooltip>
        </vs-row>
        <div>
          <br> 
    <vs-table search hoverFlat="false" :data="inactiveUserList" style="background-color: #F2F3F4; border-radius: 20px;">
      <template slot="header" >  
          <h5 class="ml-3">Inactive Users​</h5> 
      </template>
      <template slot="thead">
        <vs-th style="padding: 0px">
           <!-- <vs-checkbox v-model="seleactdatatable" :vs-value="activeUserList"></vs-checkbox> -->
           <input type="checkbox" v-model="selectAllInactive" @click="selectInactive">
        </vs-th>
        <vs-th style="padding: 0px">
        </vs-th>
        <vs-th 
         style="padding: 0px" sort-key="id">
          <span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          ID
        </vs-th>
        <vs-th style="padding: 0px" sort-key="name"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Name
        </vs-th>
        <vs-th style="padding: 0px" sort-key="username"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Username
        </vs-th>
        <vs-th style="padding: 0px" ><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Password
        </vs-th>
        <vs-th style="padding: 0px" sort-key="email"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          E-mail
        </vs-th>
        <vs-th style="padding: 0px" sort-key="email"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Role
        </vs-th>
        <vs-th style="padding: 0px" sort-key="email"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Login Status
        </vs-th>
        <!-- <vs-th style="padding: 0px"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Network
        </vs-th>
        <vs-th style="padding: 0px"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Location 
        </vs-th> -->
        <vs-th style="padding: 0px"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          LINE
        </vs-th>
        <vs-th  style="padding: 0px">
          User Status
        </vs-th>
        <!-- <vs-th style="padding: 0px"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Role
        </vs-th> -->
        
        
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr2" v-for="(tr, indextr2) in data" >
          <vs-td style="width : 40px;">
            <!-- <vs-checkbox v-model="seleactdatatable" :vs-value="data[indextr]" ></vs-checkbox> -->
            	<input type="checkbox" :value="data[indextr2].id" @click="select" v-model="selected">
          </vs-td>
          <vs-td :data="data[indextr2].active" style="width : 200px;">
              <vs-dropdown vs-trigger-click left class="cursor-pointer w3-hide-large">
               <a class="text-dark" href="#">
                   <span> <vs-icon icon="more_vert"  size="18px" color="black"></vs-icon> </span>
               </a>
        <vs-dropdown-menu class="topbar-dd">
          <vs-dropdown-item @click="view(data[indextr2])"><span><vs-icon class="mr-1" size="15px" icon="create" ></vs-icon></span>Edit</vs-dropdown-item>
          <vs-dropdown-item  @click="buttonDelete=data[indextr2],showModal()"><span><vs-icon class="mr-1" size="15px" icon="delete" ></vs-icon></span>Delete</vs-dropdown-item>
        
        </vs-dropdown-menu>
      </vs-dropdown>

                 <div class="w3-hide-small  w3-hide-medium">
                 <!-- <vs-button class="text-success mr-2 " color="success" type="flat" icon="add_circle" >View</vs-button> -->
                 <vs-button class="text-warning mr-2 " color="warning" type="flat" icon="create" @click="view(data[indextr2])">Edit</vs-button>
                  <!-- <vs-button class="text-danger mr-2 " color="danger" type="flat" icon="delete"  @click="del(data[indextr2])">Delete</vs-button> -->
                 <vs-button class="text-danger mr-2 " color="danger" type="flat" icon="delete" v-b-modal.modal-delete @click="buttonDelete=data[indextr2]">Delete</vs-button>
               </div>
          </vs-td>
           <vs-td>
            {{indextr2+1}}
          </vs-td>
          <vs-td>
            {{data[indextr2].name}}
          </vs-td>
          <vs-td>
            {{data[indextr2].username}}
          </vs-td>
          <vs-td>
            {{data[indextr2].password}}
          </vs-td>
          <vs-td>
            {{data[indextr2].email}}
          </vs-td>
          <vs-td>
           <span v-if="data[indextr2].admin==null">Admin</span>
           <span else>User </span>
          </vs-td>
           <vs-td>
            <vs-icon icon="fiber_manual_record" v-if="data[indextr2].islogin" color="#5fa74b" ></vs-icon>
            <vs-icon icon="fiber_manual_record" v-else color="#d9d9d9"></vs-icon>
          </vs-td>
          <vs-td>
            <vs-icon v-if="data[indextr2].line == null" icon="remove" color="red"></vs-icon>
            <vs-icon v-else icon="check_box" color="green"></vs-icon>
          </vs-td>
          <vs-td>
            <!-- <vs-button color="warning" type="line"  icon="person_add_disabled" id="show-btn"  @click="Reactivate(data[indextr2])" >Reactivate</vs-button> -->
             <vs-switch color="danger" v-model="switchReactivate[indextr2]" @click="reactivate(data[indextr2])">
                <span slot="on">Active</span>
                <span slot="off">Inactive</span>
              </vs-switch>
          </vs-td>
        </vs-tr>
      </template>
           </vs-table>
        </div>
      </vs-tab>
       <vs-tab icon="query_builder" label="Pending Users">
         <br>
          <vs-row>
            <vs-dropdown>
                <vs-button style="color: #111111" color="rgba(9, 30, 66, 0.04)" type="filled"  icon="toc"   id="show-btn"  >Bulk Actions</vs-button>
                <vs-dropdown-menu>
                  <vs-dropdown-item  @click="selectedInvite(selected)" >
                        <vs-icon icon="email" class="mr-1" size="15px" ></vs-icon> Invite
                  </vs-dropdown-item>
                  <vs-dropdown-item >
                      <vs-icon icon="delete" class="mr-1" size="15px" ></vs-icon> Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
              <vs-spacer />
        <vs-tooltip  text="Download a PDF" position="top" >
          <vs-button  radius class="mr-2"  color="#333f50" @click="exportPDF(printUser='pendingUsers')" type="line"   icon="picture_as_pdf"></vs-button></vs-tooltip>
          <vs-tooltip  text="Export" position="top" >
          <vs-button  class="mr-2"  radius @click="onExport(printUser='pendingUsers')" color="#333f50" type="line"  icon="cloud_download"></vs-button></vs-tooltip>
         </vs-row>
        <div>
          <br>
      <vs-table search :hoverFlat="false" :data="newUserList" style="background-color: #F2F3F4; border-radius: 20px;">
      <template slot="header" >
          <h5 class="ml-3">New Users​</h5> 
      </template>
      <template slot="thead">
         <vs-th style="padding: 0px">
           <!-- <vs-checkbox v-model="seleactdatatable" :vs-value="activeUserList"></vs-checkbox> -->
             <input type="checkbox" v-model="selectAllNew" @click="selectNew">
        </vs-th>
        <vs-th style="padding: 0px">
          
        </vs-th>
        <vs-th 
         style="padding: 0px" sort-key="id">
          <span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          ID
        </vs-th>
        <vs-th style="padding: 0px" sort-key="name"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Name
        </vs-th>
        <vs-th style="padding: 0px" sort-key="username"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Username
        </vs-th>
        <vs-th style="padding: 0px" ><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Password
        </vs-th>
        <vs-th style="padding: 0px" sort-key="email"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          E-mail
        </vs-th>
        <vs-th style="padding: 0px" sort-key="email"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Role
        </vs-th>
        <vs-th style="padding: 0px" sort-key="email"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Login Status
        </vs-th>
        <!-- <vs-th style="padding: 0px"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Network
        </vs-th>
        <vs-th style="padding: 0px"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Location 
        </vs-th> -->
        <vs-th style="padding: 0px"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          LINE
        </vs-th>
        <vs-th  style="padding: 0px">
          Invite
        </vs-th>
        <!-- <vs-th style="padding: 0px"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Role
        </vs-th> -->
        
        
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr3" v-for="(tr, indextr3) in data" >
          <vs-td style="width : 40px;">
            <!-- <vs-checkbox v-model="seleactdatatable" :vs-value="data[indextr]" ></vs-checkbox> -->
            	<input type="checkbox" :value="data[indextr3]" @click="select" v-model="selected">
          </vs-td>
          <vs-td :data="data[indextr3].active" style="width : 200px;">
             <vs-dropdown vs-trigger-click left class="cursor-pointer w3-hide-large">
               <a class="text-dark" href="#">
                   <span> <vs-icon icon="more_vert" size="18px" color="black"></vs-icon> </span>
               </a>
        <vs-dropdown-menu class="topbar-dd">
          <vs-dropdown-item @click="view(data[indextr3])"><span><vs-icon size="15px" class="mr-1" icon="create" ></vs-icon></span>Edit</vs-dropdown-item>
          <vs-dropdown-item  @click="buttonDelete=data[indextr3],showModal()"><span><vs-icon size="15px" class="mr-1" icon="delete" ></vs-icon></span>Delete</vs-dropdown-item>
        
        </vs-dropdown-menu>
      </vs-dropdown>

                 <div class="w3-hide-small  w3-hide-medium">
                 <!-- <vs-button class="text-success mr-2 " color="success" type="flat" icon="add_circle" >View</vs-button> -->
                 <vs-button class="text-warning mr-2 " color="warning" type="flat" icon="create" @click="view(data[indextr3])">Edit</vs-button>
                  <!-- <vs-button class="text-danger mr-2 " color="danger" type="flat" icon="delete"  @click="del(data[indextr3])">Delete</vs-button> -->
                 <vs-button class="text-danger mr-2 " color="danger" type="flat" icon="delete" v-b-modal.modal-delete @click="buttonDelete=data[indextr3]">Delete</vs-button></div>
          </vs-td>
           <vs-td>
            {{indextr3+1}}
          </vs-td>
          <vs-td>
            {{data[indextr3].name}}
          </vs-td>
          <vs-td>
            {{data[indextr3].username}}
          </vs-td>
          <vs-td>
            {{data[indextr3].password}}
          </vs-td>
          <vs-td>
            {{data[indextr3].email}}
          </vs-td>
          <vs-td>
           <span v-if="data[indextr3].admin==null">Admin</span>
           <span else>User </span>
          </vs-td>
           <vs-td>
            <vs-icon icon="fiber_manual_record" v-if="data[indextr3].islogin" color="#5fa74b" ></vs-icon>
            <vs-icon icon="fiber_manual_record" v-else color="#d9d9d9"></vs-icon>
          </vs-td>
          <vs-td>
            <vs-icon v-if="data[indextr3].line == null" icon="remove" color="red"></vs-icon>
            <vs-icon v-else icon="check_box" color="green"></vs-icon>
          </vs-td>
          <vs-td> 
            <vs-button color="primary" type="filled" style="width: 80px;"  icon="email" id="show-btn" v-if="data[indextr3].status=='inactive'" @click="invite(data[indextr3])" >Invite</vs-button>
            <vs-button color="primary" type="flat"  icon="email" v-if="data[indextr3].status=='pending'" id="show-btn"  @click="invite(data[indextr3])" >Invited</vs-button>
          </vs-td>
        </vs-tr>
      </template>
           </vs-table>
        </div>
      </vs-tab>
    </vs-tabs>
      <br>
    </vs-card>

    <!-- Modal for delete -->
    <b-modal id="modal-delete" ref="modal-delete" centered >
        <template #modal-title>
          <b class="text-danger"> <vs-icon icon="delete" size="small" color="red"></vs-icon>Delete User</b> 
        </template>
        <p class="my-4">Do you want to delete user?</p>
        <template #modal-footer="{ cancel }">
          <b-button id="btncancel"  variant="light" @click="cancel()">
            Cancel
          </b-button>
          <vs-button v-if="role == 'admin'" color="danger" style="border-radius: 20px;" size="sm" @click="acceptAlertDelete()" type="filled">Delete</vs-button>
        </template> 
    </b-modal>

    <!-- Modal select for delete -->
    <b-modal id="modal-selected-delete" ref="modal-selected-delete" centered >
        <template #modal-title>
          <b class="text-danger"> <vs-icon icon="delete" size="small" color="red"></vs-icon>Delete User</b> 
        </template>
        <p class="my-4">Do you want to delete {{this.selected.length}} user?</p>
        <template #modal-footer="{ cancel }">
          <b-button id="btncancel"  variant="light" @click="cancel()">
            Cancel
          </b-button>
          <vs-button v-if="role == 'admin'" color="danger" style="border-radius: 20px;" size="sm" @click="acceptSelectedDelete(selected)" type="filled">Delete</vs-button>
        </template> 
    </b-modal>
  
  
    <vs-prompt
    color="#6eda78"
    @cancel="adduser.user='',adduser.pwd='',adduser.email='',adduser.name=''"
    @accept="addUserSent"
    title="Add New User"
    :active.sync="active">
      <div class="con-exemple-prompt">
        <vs-input color="#333f50" placeholder="Name" label="Name" v-model="adduser.name"/><br>
        <vs-input color="#333f50" placeholder="Username" label="Username" v-model="adduser.user"/><br>
        <vs-input color="#333f50" placeholder="Password" label="Password" v-model="adduser.pwd"/><br>
        <vs-input color="#333f50" placeholder="E-mail" label="E-mail" v-model="adduser.email"/><br>
        <vs-alert color="#6eda78" icon="new_releases" >
          Fields can not be empty please enter the data
        </vs-alert>
      </div>
    </vs-prompt>
    <vs-prompt
    color="#6eda78"
    @cancel="edituser.user='',edituser.pwd='',edituser.email='',edituser.name=''"
    @accept="editUserSent"
    title="Edit User"
    :active.sync="active2">
      <div class="con-exemple-prompt">
        <vs-input color="#333f50" placeholder="Name" label="Name" v-model="edituser.name"/><br>
        <vs-input color="#333f50" placeholder="Username" label="Username" v-model="edituser.user"/><br>
        <vs-input color="#333f50" placeholder="Password" label="Password" v-model="edituser.pwd"/><br>
        <vs-input color="#333f50" placeholder="E-mail" label="E-mail" v-model="edituser.email"/><br>
        <vs-alert color="#6eda78" icon="new_releases" >
          Fields can not be empty please enter the data
        </vs-alert> 
      </div>
    </vs-prompt>
    <vs-prompt
    color="#6eda78"
    @cancel="editpwd.oldpwd='',editpwd.newpwd='',editpwd.recheck=''"
    @accept="editpwdsent"
    title="Edit Admin Password"
    :active.sync="active3">
      <div class="con-exemple-prompt">
        <vs-input color="#333f50" placeholder="Old Password" label="Current Password" v-model="editpwd.oldpwd"/><br>
        <vs-input color="#333f50" placeholder="New Password" label="New Password" v-model="editpwd.newpwd"/><br>
        <vs-input color="#333f50" placeholder="Confirm Password" label="Repeat Password" v-model="editpwd.recheck"/><br>
        <vs-alert color="#6eda78" icon="new_releases" >
          Fields can not be empty please enter the data
        </vs-alert> 
      </div>
    </vs-prompt>
    <vs-prompt
    color="#6eda78"
    @cancel="editemail.email=''"
    @accept="editemailsent"
    title="Admin E-mail"
    :active.sync="active4">
      <div class="con-exemple-prompt">
        <vs-input color="#333f50" placeholder="New E-mail" label="New E-mail" v-model="editemail.email"/><br>
        <vs-alert color="#6eda78" icon="new_releases" >
          Fields can not be empty please enter the data
        </vs-alert> 
      </div>
    </vs-prompt>


 <b-modal id="adduser1" no-close-on-backdrop="false" hide-header-close centered hide-footer  size="lg" >
           <template #modal-title>
     <h4 style="color: #5fa74b">Add New User</h4> 
    </template>
     <vs-row class="ml-1 mb-3"  vs-w="12">
       <h6>User Details</h6>
     </vs-row>

     <vs-row  vs-w="12">
  <vs-col class="mb-3" vs-type="flex" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12" >
   <vs-input style="width: 310PX" color="#333f50" placeholder="Name" label="Name" v-model="adduser.name"/>
  </vs-col>
  <vs-col class="mb-3" vs-type="flex" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
    <vs-input style="width: 310PX" color="#333f50" placeholder="E-mail" label="E-mail" v-model="adduser.email"/>
    
  </vs-col>
  
</vs-row>
 <vs-row  vs-w="12">
  <vs-col class="mb-3" vs-type="flex" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12" >
   <vs-input style="width: 310PX" color="#333f50" placeholder="Username" label="Username" v-model="adduser.user"/>
  </vs-col>
  <vs-col class="mb-3" vs-type="flex" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
    <vs-input  style="width: 310PX" color="#333f50" placeholder="Password" label="Password" v-model="adduser.pwd"/>
    
  </vs-col>
  
</vs-row>


<vs-row class="ml-3 mt-3" vs-w="12">
 <vs-spacer />
   <vs-button type="filled" size="sm" style="border-radius: 20px;" color="success" @click="addUserSent()">Add User</vs-button>
 
 <b-button class="ml-2 mr-4" id="btncancel"  variant="light" @click="cancel()">
        Cancel
      </b-button>
 
</vs-row>
         
  </b-modal>
  </div>
</template>

<script>
import XLSX from 'xlsx' // import xlsx
import moment from 'moment'
import html2pdf from 'html2pdf.js'
import jsPDF  from 'jspdf'
import 'jspdf-autotable'
export default {
  name: '/User',
  data: () => ({
    selected: [],
		selectAllActive: false,
    selectAllInactive: false,
    selectAllNew: false,
    codePassword:'✱ ✱ ✱',
    switchReactivate: [],
    role: '',
    datat:'',
    switchReactivate:true,
    admin: '',
    buttonDelete: '',
    active: false,
    active2: false,
    active3: false,
    active4: false,
    adduser:{
      name: '',
      user:'',
      pwd:'',
      email:'',
    },
    edituser:{
      name: '',
      user:'',
      pwd:'',
      email:'',
    },
    editpwd: {
      oldpwd: '',
      newpwd: '',
      recheck: ''
    },
    editemail: {
      email: ''
    },
    userList: [],
    activeUserList: [],
    inactiveUserList: [],
    newUserList: [],
    headerList:'',
    printUser: '',
    dataBody: [],
    dataExport: [],
  }),
  methods: {
    // export PDF
     exportPDF(param) {
      console.log(param)
        switch (param) {
            case 'activeUsers':
                this.headerList = 'Active Users'
                  this.activeUserList.forEach(element => {
                    this.dataBody.push({name: element.name,username: element.username,email: element.email,line: element.line,islogin: element.islogin,status: element.status});
                  });
                break;
            case 'inactiveUsers':
                this.headerList = 'Inactive Users'
                  this.inactiveUserList.forEach(element => {
                    this.dataBody.push({name: element.name,username: element.username,email: element.email,line: element.line,islogin: element.islogin,status: element.status});
                  });
                break;
            case 'pendingUsers':
                this.headerList = 'Pending Users'
                  this.newUserList.forEach(element => {
                    this.dataBody.push({name: element.name,username: element.username,email: element.email,line: element.line,islogin: element.islogin,status: element.status});
                  });
                break;
            }
      console.log(this.headerList,this.dataBody)
      var doc = new jsPDF('p', 'pt');
      doc.setFontSize(11).text(this.headerList, 40, 40);
      var newDat = moment().format('MM/DD/YYYY hh:mm:ss');
      doc.setFontSize(7).text(505,25,newDat); // set timestamp
      var values = this.dataBody.map( (elemento) => Object.values(elemento));
      console.log(values)
      doc.autoTable({theme: 'striped',headStyles: {fillColor: [105, 181, 83] ,textColor: [255, 255, 255]} , styles: { fontSize: 8 ,theme: 'plain'},
          head: [['Name','username','Email','Line','islogin','Status']],
          body: values,margin: {top: 50}
      })
      doc.save(param+'.pdf');
      this.dataBody = []; //clear databody
      this.printUser = ''; //clear printUser
    },
    // export xlsx
    onExport(param) {
      console.log(param)
        switch (param) {
            case 'activeUsers':
                  this.activeUserList.forEach(element => {
                    this.dataExport.push({name: element.name,username: element.username,email: element.email,line: element.line,islogin: element.islogin,status: element.status});
                  });
                break;
            case 'inactiveUsers':
                  this.inactiveUserList.forEach(element => {
                    this.dataExport.push({name: element.name,username: element.username,email: element.email,line: element.line,islogin: element.islogin,status: element.status});
                  });
                break;
            case 'pendingUsers':
                  this.newUserList.forEach(element => {
                    this.dataExport.push({name: element.name,username: element.username,email: element.email,line: element.line,islogin: element.islogin,status: element.status});
                  });
                break;
            }
      console.log(this.dataExport)
      const dataWS = XLSX.utils.json_to_sheet(this.dataExport)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb,param+'.xlsx')
      this.dataExport = []; //clear databody
      this.printUser = ''; //clear printUser
    },
     showModalSelectedDelete() {
        this.$refs['modal-selected-delete'].show()
      },
    showModal() {
        this.$refs['modal-delete'].show()
      },
    selectActive() {
			this.selected = [];
			if (!this.selectAllActive) {
				for (let i in this.activeUserList) {
					this.selected.push(this.activeUserList[i].id);
				}
			}
		},
    select: function() {
            this.selectAllActive = false;
            this.selectAllInactive = false;
            this.selectAllNew = false;
    },
    selectInactive() {
			this.selected = [];
			if (!this.selectAllInactive) {
				for (let i in this.inactiveUserList) {
					this.selected.push(this.inactiveUserList[i].id);
				}
			}
		},
    selectNew() {
			this.selected = [];
			if (!this.selectAllNew) {
				for (let i in this.newUserList) {
					this.selected.push(this.newUserList[i]);
				}
			}
		},
    add() {
      this.active = true
    },
    cancel(){
       location.reload();
    },
    addUserSent() {
      if(this.$session.get('username') == 'poonsak.ngk')
      var url = this.$url+'account'
      else
      var url = this.$url2+'account'
      this.$http.post(url, {
        headers: {
                  'Access-Control-Request-Method': '*',
                  'Access-Control-Request-Headers': '*',
                  'Origin': '*'
                },
          name: this.adduser.name,
          username: this.adduser.user,
          password: this.adduser.pwd,
          email: this.adduser.email,
          admin: this.$session.get('username'),
          permission: ['All']
      }).then((result) => {
        if(result) {
          this.$vs.notify({
            title: "Register",
            text: "Successful!",
            color: "success",
            position: "top-center",
            icon: 'check'
          });
          setTimeout(() => {
            location.reload()
          }, 300);
        }
      }).catch((err) => {
        if(err) {
          this.$vs.notify({
            title: "Register was unsuccessful",
            text: "Something wrong.",
            color: "danger",
            position: "top-center",
            icon: 'clear'
          });
        }
      })
    },
    edit(item) {
      this.edituser.name = item.name
      this.edituser.user = item.username
      this.edituser.pwd = item.password
      this.edituser.email = item.email
      this.edituser.id = item.id
      this.active2 = true
    },
    // del(item) {
    //   this.deltarget = item
    //   this.$vs.dialog({
    //     type:'confirm',
    //     color: 'danger',
    //     title: 'Confirm',
    //     text: 'Confirm Delete User?',
    //     accept:this.acceptAlertDelete
    //   })
    // },
    acceptSelectedDelete(item){
      for(let i =0 ; i < item.length ; i++){
        console.log(item[i])
      this.$http.post(this.$url+'deleteaccount', {
        id: item[i]
      }).then(() => {
        this.$vs.notify({
          color:'success',
          title:'Deleted User',
          text:'The selected user was successfully deleted'
        })
        setTimeout(() => {
          location.reload()
        }, 300);
      }).catch((err) => {
        
        this.$vs.notify({
          color:'danger',
          title:'Deleted User',
          text:'The selected user was failed to delete'
        })
      })}
    },
    acceptAlertDelete(){
      console.log(this.buttonDelete)
      this.$http.post(this.$url2+'deleteaccount', {
        id: this.buttonDelete.id
      }).then(() => {
        this.$vs.notify({
          color:'success',
          title:'Deleted User',
          text:'The selected user was successfully deleted'
        })
        setTimeout(() => {
          location.reload()
        }, 300);
      }).catch((err) => {
        
        this.$vs.notify({
          color:'danger',
          title:'Deleted User',
          text:'The selected user was failed to delete'
        })
      })
    },
    inactivate(item){
      console.log (item.email, item.name)
      // this.$vs.notify({title:'Inactivate',text:'Lorem ipsum dolor sit amet, consectetur',color:'primary',position:'top-center'})
      console.log(item.id)
      this.$vs.loading()
      setTimeout( ()=> {
            this.$http.get(this.$url2+'inactivate/'+ item.id +'/'+this.$session.get('token')).then((response) => {
              location.reload();
            })
              this.$vs.loading.close()
      }, 1000);
      // console.log(this.$url+'inactivate/'+item.id+'/'+this.$session.get('token'))
    },
    selectedInactivate(item){
       console.log ('Inactivate '+item)
       this.$vs.loading()
      setTimeout( ()=> {
            for(let i =0 ; i < item.length ; i++){
      this.$http.get(this.$url2+'inactivate/'+ item[i] +'/'+this.$session.get('token')).then((response) => {
              location.reload();
            })}
              this.$vs.loading.close()
      }, 1000);
    },
    selectedReinvite(item){
       console.log ('vmvkkvv')
       console.log ('Reinvite ' + item)
       for(let i =0 ; i < item.length ; i++){
       this.$http.get(this.$url2+'reinvite/'+ item[i] +'/'+this.$session.get('token')).then((response) => {
             console.log (this.$url2+'reinvite/'+ item[i] +'/'+this.$session.get('token'))
            })}
      //  this.$http.get(this.$url2+'reinvite/'+item.id+'/'+this.$session.get('token')).then((response) => {
      //   location.reload();
      // })
     
     },
     reinvite(item){
      console.log (item.email, item.name)
      this.$http.get(this.$url2+'reinvite/'+item.id+'/'+this.$session.get('token')).then((response) => {
         console.log (this.$url2+'reinvite/'+item.id+'/'+this.$session.get('token'))
        // location.reload();
      })
     },
    reactivate(item){
       console.log (item.email, item.name)
        console.log(item.id)
        this.$vs.loading()
      setTimeout( ()=> {
         this.$http.get(this.$url2+'reactivate/'+item.id+'/'+this.$session.get('token')).then((response) => {
        location.reload();
      })
        this.$vs.loading.close()
      }, 1000);
    },
    selectedReactivate(item){
       console.log (item.email, item.name)
        console.log(item.id)
        this.$vs.loading()
      setTimeout( ()=> {
        for(let i =0 ; i < item.length ; i++){
         this.$http.get(this.$url2+'reactivate/'+item[i]+'/'+this.$session.get('token')).then((response) => {
        location.reload();
      })}
        this.$vs.loading.close()
      }, 1000);
       
    },
    // invite2nonononononononono for i
    selectedInvite(item){
      console.log (item)
      for(let i =0 ; i < item.length ; i++){
      console.log (item[i].name)
      
      var url = 'http://localhost:8080/#/Resetpassword'
      var body = {
        column: "*",
        name: item[i].name,
        email: item[i].email,
        username: item[i].username,
        id: item[i].id,
        url: url
      };
      // console.log (this.body[0])
      
      this.$http.post(this.$url2+'inviteuser/'+this.$session.get('token'),body, {
        headers: {
                  'Access-Control-Request-Method': '*',
                  'Access-Control-Request-Headers': '*',
                  'Access-Control-Allow-Origin': '*'
                },
        username: "admin",
        password: "admin",
        role: this.checkbox
      }).then((result) => {
        console.log(result.status)
        location.reload();

        if(result) {
          this.$vs.notify({
            title: "Invite",
            text: "Invitation Sent!",
            color: "success",
            position: "top-center",
            icon: 'check'
          }
          );
         
        }
      }
      ).catch((err) => {
        if(err.response.status == 403) {
          console.log(err)
          this.$vs.notify({
            title: "Invite Failed",
            text: "Verification Pending",
            color: "danger",
            position: "top-center",
            icon: 'clear'
          });
        }
        else if(err.response.status == 500){
          this.$vs.notify({
            title: "Invite Failed",
            text: "Verification Timeout",
            color: "danger",
            position: "top-center",
            icon: 'clear'
          });
        }
      })}
    },
    invite(item){
      // console.log (item.email, item.name)
      var url = 'http://localhost:8080/#/Resetpassword'
      var body = {
        column: "*",
        name: item.name,
        email: item.email,
        username: item.username,
        id: item.id,
        url: url
      };
      this.$http.post(this.$url2+'inviteuser/'+this.$session.get('token'),body
      // , {
      //   headers: {
      //             'Access-Control-Request-Method': '*',
      //             'Access-Control-Request-Headers': '*',
      //             'Access-Control-Allow-Origin': '*'
      //           },
      //   username: "admin",
      //   password: "admin",
      //   role: this.checkbox
      // }
      ).then((result) => {
        // console.log(result.status)
        if(result) {
          this.$vs.notify({
            title: "Invite",
            text: "Invitation Sent!",
            color: "success",
            position: "top-center",
            icon: 'check'
          });
          location.reload();
        }
      }).catch((err) => {
        if(err.response.status == 403) {
          // console.log(err)
          this.$vs.notify({
            title: "Invite Failed",
            text: "Verification Pending",
            color: "danger",
            position: "top-center",
            icon: 'clear'
          });
        }
        else if(err.response.status == 500){
          this.$vs.notify({
            title: "Invite Failed",
            text: "Verification Timeout",
            color: "danger",
            position: "top-center",
            icon: 'clear'
          });
        }
      })
    },
    view(item){
      this.$router.push({
      name: 'PermissionSetting',
      params: {
        user: item
        }
      })
    },
    editUserSent() {
      this.$http.post(this.$url+'updateaccount', {
        headers: {
                  'Access-Control-Request-Method': '*',
                  'Access-Control-Request-Headers': '*',
                  'Origin': '*'
                },
          name: this.edituser.name,
          username: this.edituser.user,
          password: this.edituser.pwd,
          email: this.edituser.email,
          admin: this.$session.get('username'),
          permission: ['All'],
          id: this.edituser.id
      }).then((result) => {
        if(result) {
          this.$vs.notify({
            title: "Edit",
            text: "Successful!",
            color: "success",
            position: "top-center",
            icon: 'check'
          });
        }
      }).catch((err) => {
        if(err) {
          this.$vs.notify({
            title: "Edit was unsuccessful",
            text: "Something wrong.",
            color: "danger",
            position: "top-center",
            icon: 'clear'
          });
        }
      })
    },
    editAdminPWD() {
      this.active3 = true
    },
    editpwdsent() {
      if(this.editpwd.oldpwd != this.admin.password) {
        this.$vs.notify({
            title: "Password",
            text: "Current password do not match",
            color: "danger",
            position: "top-center",
            icon: 'clear'
          });
      }else if(this.editpwd.newpwd != this.editpwd.recheck) {
        this.$vs.notify({
            title: "Password",
            text: "New password and Repeat password do not match",
            color: "danger",
            position: "top-center",
            icon: 'clear'
          });
      }else{
        this.$vs.notify({
            title: "Password",
            text: "Change Successful!",
            color: "success",
            position: "top-center",
            icon: 'check'
          });
        this.$http.post(this.$url+'updatepwd', {
          headers: {
                    'Access-Control-Request-Method': '*',
                    'Access-Control-Request-Headers': '*',
                    'Origin': '*'
                  },
          password: this.editpwd.newpwd,
          admin: this.$session.get('username'),
      }).then((result) => {
        if(result) {
          this.$vs.notify({
            title: "Update Password",
            text: "Successful!",
            color: "success",
            position: "top-center",
            icon: 'check'
          });
        }
      }).catch((err) => {
        if(err) {
          this.$vs.notify({
            title: "Update password was unsuccessful",
            text: "Something wrong.",
            color: "danger",
            position: "top-center",
            icon: 'clear'
          });
        }
      })
      }
    },
    editadminemail() {
      this.active4 = true
    },
    editemailsent() {
      this.$http.post(this.$url+'updateemail', {
        headers: {
                  'Access-Control-Request-Method': '*',
                  'Access-Control-Request-Headers': '*',
                  'Origin': '*'
                },
          email: this.editemail.email,
          admin: this.$session.get('username')
      }).then((result) => {
        if(result) {
          this.$vs.notify({
            title: "Update E-mail",
            text: "Successful!",
            color: "success",
            position: "top-center",
            icon: 'check'
          });
        }
      }).catch((err) => {
        if(err) {
          this.$vs.notify({
            title: "Update E-mail was unsuccessful",
            text: "The user is already exist.",
            color: "danger",
            position: "top-center",
            icon: 'clear'
          });
        }
      })
    },
  },
  created() {
    this.role = this.$session.get('role')
    this.$http.get(this.$url+'getAdmin/'+this.$session.get('token')).then((result) => {
      this.admin = result.data[0]
      // eslint-disable-next-line no-console
      // console.log(this.admin)
    })
    this.$http.get(this.$url+'account/'+this.$session.get('token')).then((result) => {
      this.userList = result.data
      // eslint-disable-next-line no-console
      for(let i=0;i<this.userList.length;i++){
        if(this.userList[i].verify == true && this.userList[i].status== 'active'){
          this.activeUserList.push(this.userList[i])
        }
        else if(this.userList[i].verify == true && this.userList[i].status== 'inactive'){
          this.inactiveUserList.push(this.userList[i])
        }
        else if(this.userList[i].verify == false && this.userList[i].status== 'pending'){
          this.$http.get(this.$url2+'checkpendingtime/'+this.userList[i].id).then((result) =>{
            if(result){
              this.newUserList.push(result.data[0])
            }
          }).catch((err) => {
            if(err){
              // console.log('Error')
            }
          })
        }
        else if(this.userList[i].verify == false && this.userList[i].status== 'inactive'){
          this.newUserList.push(this.userList[i])
        }
      }
      // console.log(this.newUserlist)
    })
  }
}
</script>
<style  scoped>
.center{
   display: flex;
  align-items: center;
}
.vs-button{
  border-radius: 20px;
}
#btncancel{
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
th .sort-th .th-sort-icon {
    color: #ffffff !important
}
</style>

